import React from 'react';
import PropTypes from 'prop-types';

import BaseChip from '../BaseChip';

const Tag = ({ size, isDarkMode, isOverlay, ...props }) => (
  <BaseChip
    size={size} // TODO: size prop is not yet implemented in BaseChip component
    colorSchema={BaseChip.SCHEMAS.tag}
    isDarkMode={isDarkMode}
    isOverlay={isOverlay}
    {...props}
  />
);

export default Tag;

Tag.defaultProps = {
  isDarkMode: false,
  isOverlay: false,
  size: 'medium'
};

Tag.propTypes = {
  ...BaseChip.propTypes,
  isDarkMode: PropTypes.bool,
  isOverlay: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium'])
};
